export default "__VITE_ASSET__CyA2Bdn0__"